import { ChannelAsset, ChannelType } from '../../data/channel/types';
import { KalturaLiveAsset } from '../objects';
import { fromKalturaBoolean } from '../utils';

import { processPhoenixImages } from './processing';

export const processChannel = (asset: KalturaLiveAsset): ChannelAsset => {
  return {
    blockFastForward: fromKalturaBoolean(asset.metas['Block_Fast_Forward']),
    catchUpBuffer: asset.catchUpBuffer,
    ...(asset.metas['ChannelNumber'] && {
      channelNumber: Number(asset.metas['ChannelNumber'].value),
    }),
    channelType: asset.metas['LinearChannelType'] as unknown as ChannelType,
    enableCatchUp: asset.enableCatchUp,
    enableStartOver: asset.enableStartOver,
    enableTrickPlay: asset.enableTrickPlay,
    externalId: asset.externalId,
    id: asset.id,
    images: processPhoenixImages(asset.images),
    isAdult: fromKalturaBoolean(asset.metas['Adult']),
    ...(asset.tags['ParentalRating'] && {
      parentalRating: Number(asset.tags['ParentalRating'].objects[0].value),
    }),
    representPackage: fromKalturaBoolean(asset.metas['RepresentPackage']),
    supportsMosaic: fromKalturaBoolean(asset.metas['MosaicSupport']),
    title: asset.name,
    type: 'linear',
  };
};
